export default __webpack_public_path__ + "static/4i-09172b1910dff418491f31e28ca0c1d8.woff2";